module.exports = __webpack_public_path__ + "static/media/application-process.f03a8628.png";